import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// https://ngrx.io/guide/store-devtools/recipes/exclude
export const extModules = [
  StoreDevtoolsModule.instrument({
    maxAge: 25
  })
];
